import cn from 'classnames';

interface StepTagProps {
  label: string;
  variant?: 'application-system';
}

const StepTag: React.FC<StepTagProps> = ({ label, variant }) => (
  <p className={cn('step-tag', variant && `step-tag--${variant}`)}>{label}</p>
);

StepTag.displayName = 'StepTag';

export default StepTag;
